"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pictogramBeaconList = exports.pictogramList = void 0;
exports.pictogramList = [
    'Accessibility64',
    'Accounts40',
    'Accounts48',
    'Accounts64',
    'Alert40',
    'Alert64',
    'Awards40',
    'Appreciation48',
    'Branch40',
    'Branch48',
    'Branch64',
    'Business40',
    'Business48',
    'Business64',
    'BusinessOverdraft40',
    'BusinessCashFlow40',
    'BusinessCashFlow48',
    'BusinessCashFlow64',
    'BusinessVehicle40',
    'BusinessVehicle64',
    'Calendar40',
    'Calendar64',
    'Camera64',
    'Cards40',
    'Cards48',
    'Cards64',
    'Cards128',
    'Careers64',
    'CarInsurance40',
    'Cash40',
    'Cash48',
    'Cash64',
    'CashFlow40',
    'CashFlow48',
    'CashFlow64',
    'Celebration48',
    'Celebration64',
    'CertificateAuthorise64',
    'CertificateBirth64',
    'CertificateEducation64',
    'Clock64',
    'Control64',
    'Currency40',
    'DebtConsolidation64',
    'Dental40',
    'Desktop64',
    'DigiWallet40',
    'Disability64',
    'Document64',
    'Donations40',
    'Donations64',
    'Download64',
    'ECommerce48',
    'ECommerce64',
    'ECommerce128',
    'EFTPOS40',
    'EFTPOS48',
    'EFTPOS64',
    'EFTPOS128',
    'EatingOut64',
    'Education64',
    'Entertainment64',
    'Family40',
    'Family64',
    'Feedback48',
    'FeesAndInterest64',
    'File64',
    'FinancialPlanning40',
    'FinancialPlanning64',
    'Flight40',
    'Flight64',
    'ForeignCurrency40',
    'ForeignCurrency48',
    'ForeignCurrency64',
    'GreenLoan40',
    'GreenLoan48',
    'GreenLoan64',
    'Groceries64',
    'Group40',
    'GroupedAccounts40',
    'Health48',
    'HealthInsurance48',
    'HealthInsurance64',
    'Help40',
    'Help64',
    'Home64',
    'HomeBuying40',
    'HomeBuying48',
    'HomeBuying64',
    'ID64',
    'Ideas64',
    'Industry64',
    'Insights40',
    'Instalments64',
    'Insurance40',
    'Insurance48',
    'Insurance64',
    'Interest40',
    'International40',
    'International48',
    'International64',
    'International128',
    'Investments64',
    'Klarna40',
    'Lock64',
    'Look64',
    'Mail48',
    'Mail64',
    'Mail128',
    'Manage40',
    'Manage64',
    'Marketplace40',
    'MasterCard40',
    'Medicare64',
    'Microphone64',
    'Mobile40',
    'Mobile48',
    'Mobile64',
    'Mobile128',
    'MoneyIn40',
    'MoneyIn48',
    'MoneyIn64',
    'MoneyOut40',
    'MoneyOut48',
    'MoneyOut64',
    'MultipleDocuments40',
    'MultipleDocuments64',
    'Online40',
    'Online48',
    'Online64',
    'People48',
    'People64',
    'Person40',
    'Person64',
    'Print64',
    'Process40',
    'Promotion40',
    'Promotion64',
    'Qualified64',
    'Renovations40',
    'Renovations64',
    'Repayments40',
    'Saving40',
    'Saving48',
    'Saving64',
    'Search40',
    'Search64',
    'Security40',
    'Security64',
    'Share40',
    'Share64',
    'Shares40',
    'Shares48',
    'Shares64',
    'Shopping40',
    'Shopping64',
    'Sign64',
    'SmarterDecisions40',
    'StandardVehicle40',
    'StandardVehicle48',
    'StandardVehicle64',
    'Superannuation40',
    'Superannuation48',
    'Superannuation64',
    'Tax40',
    'Transfer40',
    'Travel40',
    'Trauma40',
    'TermDeposit40',
    'TermDeposit48',
    'TermDeposit64',
    'TermDeposits48',
    'TerminalEssential128',
    'TerminalSmart128',
    'ThumbDown48',
    'ThumbUp40',
    'ThumbUp48',
    'ThumbUp64',
    'ToAdd64',
    'Tools64',
    'Tools128',
    'Transfer64',
    'Trash64',
    'Trauma64',
    'Travel48',
    'Travel64',
    'Undefined64',
    'Unlock64',
    'Upload64',
    'Utilities64',
    'UtilityGas64',
    'UtilityNonMains64',
    'UtilityWater64',
    'Valuable40',
    'Valuable48',
    'Valuable64',
];
exports.pictogramBeaconList = [
    'Accessibility40',
    'Accessibility48',
    'Accessibility64',
    'Accessibility128',
    'Accounts40',
    'Accounts48',
    'Accounts64',
    'Accounts128',
    'Alert40',
    'Alert48',
    'Alert64',
    'Alert128',
    'Appreciation40',
    'Appreciation48',
    'Appreciation64',
    'Appreciation128',
    'ATM40',
    'ATM48',
    'ATM64',
    'ATM128',
    'Awards40',
    'Awards48',
    'Awards64',
    'Awards128',
    'BNPL40',
    'BNPL48',
    'BNPL64',
    'BNPL128',
    'Branch40',
    'Branch48',
    'Branch64',
    'Branch128',
    'Briefcase40',
    'Briefcase48',
    'Briefcase64',
    'Briefcase128',
    'Business40',
    'Business48',
    'Business64',
    'Business128',
    'BusinessVehicle40',
    'BusinessVehicle48',
    'BusinessVehicle64',
    'BusinessVehicle128',
    'Calendar40',
    'Calendar48',
    'Calendar64',
    'Calendar128',
    'Camera40',
    'Camera48',
    'Camera64',
    'Camera128',
    'Cards40',
    'Cards48',
    'Cards64',
    'Cards128',
    'CarbonOffset40',
    'CarbonOffset48',
    'CarbonOffset64',
    'CarbonOffset128',
    'CarbonTracker40',
    'CarbonTracker48',
    'CarbonTracker64',
    'CarbonTracker128',
    'CarbonTrees40',
    'CarbonTrees48',
    'CarbonTrees64',
    'CarbonTrees128',
    'Cash40',
    'Cash48',
    'Cash64',
    'Cash128',
    'CashCode40',
    'CashCode48',
    'CashCode64',
    'CashCode128',
    'Categories40',
    'Categories48',
    'Categories64',
    'Categories128',
    'Ceba40',
    'Ceba48',
    'Ceba64',
    'Ceba128',
    'Celebration40',
    'Celebration48',
    'Celebration64',
    'Celebration128',
    'CertificateAuthorise40',
    'CertificateAuthorise48',
    'CertificateAuthorise64',
    'CertificateAuthorise128',
    'CertificateEducation40',
    'CertificateEducation48',
    'CertificateEducation64',
    'CertificateEducation128',
    'Clock40',
    'Clock48',
    'Clock64',
    'Clock128',
    'Control40',
    'Control48',
    'Control64',
    'Control128',
    'Currency40',
    'Currency48',
    'Currency64',
    'Currency128',
    'DebtConsolidation40',
    'DebtConsolidation48',
    'DebtConsolidation64',
    'DebtConsolidation128',
    'Dental40',
    'Dental48',
    'Dental64',
    'Dental128',
    'Desktop40',
    'Desktop48',
    'Desktop64',
    'Desktop128',
    'DigiWallet40',
    'DigiWallet48',
    'DigiWallet64',
    'DigiWallet128',
    'Disability40',
    'Disability48',
    'Disability64',
    'Disability128',
    'Document40',
    'Document48',
    'Document64',
    'Document128',
    'Donations40',
    'Donations48',
    'Donations64',
    'Donations128',
    'Download40',
    'Download48',
    'Download64',
    'Download128',
    'EarthHeart40',
    'EarthHeart48',
    'EarthHeart64',
    'EarthHeart128',
    'EatingOut40',
    'EatingOut48',
    'EatingOut64',
    'EatingOut128',
    'Education40',
    'Education48',
    'Education64',
    'Education128',
    'EFTPOS40',
    'EFTPOS48',
    'EFTPOS64',
    'EFTPOS128',
    'Entertainment40',
    'Entertainment48',
    'Entertainment64',
    'Entertainment128',
    'Family40',
    'Family48',
    'Family64',
    'Family128',
    'Feedback40',
    'Feedback48',
    'Feedback64',
    'Feedback128',
    'FeesAndInterest40',
    'FeesAndInterest48',
    'FeesAndInterest64',
    'FeesAndInterest128',
    'File40',
    'File48',
    'File64',
    'File128',
    'FinancialPlanning40',
    'FinancialPlanning48',
    'FinancialPlanning64',
    'FinancialPlanning128',
    'Groceries40',
    'Groceries48',
    'Groceries64',
    'Groceries128',
    'Guarantee40',
    'Guarantee48',
    'Guarantee64',
    'Guarantee128',
    'Health40',
    'Health48',
    'Health64',
    'Health128',
    'Help40',
    'Help48',
    'Help64',
    'Help128',
    'HomeBuying40',
    'HomeBuying48',
    'HomeBuying64',
    'HomeBuying128',
    'Idea40',
    'Idea48',
    'Idea64',
    'Idea128',
    'Insights40',
    'Insights48',
    'Insights64',
    'Insights128',
    'Institution40',
    'Institution48',
    'Institution64',
    'Institution128',
    'Insurance40',
    'Insurance48',
    'Insurance64',
    'Insurance128',
    'International40',
    'International48',
    'International64',
    'International128',
    'Investments40',
    'Investments48',
    'Investments64',
    'Investments128',
    'Location40',
    'Location48',
    'Location64',
    'Location128',
    'Lock40',
    'Lock48',
    'Lock64',
    'Lock128',
    'Look40',
    'Look48',
    'Look64',
    'Look128',
    'Mail40',
    'Mail48',
    'Mail64',
    'Mail128',
    'Manage40',
    'Manage48',
    'Manage64',
    'Manage128',
    'Marketplace40',
    'Marketplace48',
    'Marketplace64',
    'Marketplace128',
    'Medicare40',
    'Medicare48',
    'Medicare64',
    'Medicare128',
    'Microphone40',
    'Microphone48',
    'Microphone64',
    'Microphone128',
    'Mobile40',
    'Mobile48',
    'Mobile64',
    'Mobile128',
    'Modem40',
    'Modem48',
    'Modem64',
    'Modem128',
    'MoneyIn40',
    'MoneyIn48',
    'MoneyIn64',
    'MoneyIn128',
    'MoneyOut40',
    'MoneyOut48',
    'MoneyOut64',
    'MoneyOut128',
    'MultipleDocuments40',
    'MultipleDocuments48',
    'MultipleDocuments64',
    'MultipleDocuments128',
    'Online40',
    'Online48',
    'Online64',
    'Online128',
    'PayIn40',
    'PayIn48',
    'PayIn64',
    'PayIn128',
    'Person40',
    'Person48',
    'Person64',
    'Person128',
    'PieGraph40',
    'PieGraph48',
    'PieGraph64',
    'PieGraph128',
    'Portfolio40',
    'Portfolio48',
    'Portfolio64',
    'Portfolio128',
    'Present40',
    'Present48',
    'Present64',
    'Present128',
    'Print40',
    'Print48',
    'Print64',
    'Print128',
    'PrizeDraw40',
    'PrizeDraw48',
    'PrizeDrawWin40',
    'PrizeDrawWin48',
    'Process40',
    'Process48',
    'Process64',
    'Process128',
    'Promotion40',
    'Promotion48',
    'Promotion64',
    'Promotion128',
    'Renovations40',
    'Renovations48',
    'Renovations64',
    'Renovations128',
    'Repayments40',
    'Repayments48',
    'Repayments64',
    'Repayments128',
    'Saving32',
    'Saving40',
    'Saving48',
    'Saving64',
    'Saving128',
    'Search40',
    'Search48',
    'Search64',
    'Search128',
    'Security40',
    'Security48',
    'Security64',
    'Security128',
    'Share40',
    'Share48',
    'Share64',
    'Share128',
    'Shares40',
    'Shares48',
    'Shares64',
    'Shares128',
    'Shopping40',
    'Shopping48',
    'Shopping64',
    'Shopping128',
    'Shortcuts40',
    'Shortcuts48',
    'Shortcuts64',
    'Shortcuts128',
    'Sign40',
    'Sign48',
    'Sign64',
    'Sign128',
    'StandardVehicle40',
    'StandardVehicle48',
    'StandardVehicle64',
    'StandardVehicle128',
    'Superannuation40',
    'Superannuation48',
    'Superannuation64',
    'Superannuation128',
    'TermDeposit40',
    'TermDeposit48',
    'TermDeposit64',
    'TermDeposit128',
    'ThumbsDown40',
    'ThumbsDown48',
    'ThumbsDown64',
    'ThumbsDown128',
    'ThumbsUp40',
    'ThumbsUp48',
    'ThumbsUp64',
    'ThumbsUp128',
    'Tools40',
    'Tools48',
    'Tools64',
    'Tools128',
    'Transfer40',
    'Transfer48',
    'Transfer64',
    'Transfer128',
    'Trash40',
    'Trash48',
    'Trash64',
    'Trash128',
    'Trauma40',
    'Trauma48',
    'Trauma64',
    'Trauma128',
    'Travel40',
    'Travel48',
    'Travel64',
    'Travel128',
    'Uncategorised40',
    'Uncategorised48',
    'Uncategorised64',
    'Uncategorised128',
    'Unlock40',
    'Unlock48',
    'Unlock64',
    'Unlock128',
    'Upload40',
    'Upload48',
    'Upload64',
    'Upload128',
    'Utilities40',
    'Utilities48',
    'Utilities64',
    'Utilities128',
    'UtilityGas40',
    'UtilityGas48',
    'UtilityGas64',
    'UtilityGas128',
    'UtilityNonMains40',
    'UtilityNonMains48',
    'UtilityNonMains64',
    'UtilityNonMains128',
    'UtilityWater40',
    'UtilityWater48',
    'UtilityWater64',
    'UtilityWater128',
    'Valuable40',
    'Valuable48',
    'Valuable64',
    'Valuable128',
];
